import { render, staticRenderFns } from "./WaveImageBlock.vue?vue&type=template&id=6b9d160d"
import script from "./WaveImageBlock.vue?vue&type=script&lang=js"
export * from "./WaveImageBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports